import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';

import ClipboardCopyComponent from 'webapp/components/clipboard-copy';
import CommonUiIconComponent from 'webapp/components/common/ui-icon';

import type InfolayerItem from 'webapp/models-custom/infolayer-item/data-export';

interface Args {
	model: InfolayerItem;
	onClose: () => void;
}

export default class InfolayerTypeDataExportComponent extends Component<Args> {
	@service('analytics') declare analyticsService: Service.Analytics;
	@service('infolayer') declare infolayerService: Service.Infolayer;
	@service('model-manager/activity-logs')
	declare mmActivityLogsService: Service.ModelManager.ActivityLogs;

	@action
	download(): void {
		const dataExportDelivery = this.args.model.dataExportDelivery;

		// TODO: Datasets - Add activity log

		if (dataExportDelivery.url) {
			window.open(dataExportDelivery.url);
			this.args.onClose();
		}
	}

	@action
	onAfterCopyToClipboard(): void {
		// TODO: Datasets - Add tracking
		this.infolayerService.ok('Data export URL copied to clipboard!');
		this.args.onClose();
	}
	<template>
		<div
			role="button"
			class="infolayer infolayer--type-data-export {{@model.classes}}"
			{{on "click" @onClose}}
		>
			<div>
				<CommonUiIconComponent @name="Csv" @size="lg" @class="infolayer-icon" />
				{{#if @model.isLoading}}
					<p>
						Your data export of
						<strong>“{{@model.dataExportDelivery.name}}”</strong>
						is being generated. Depending on the amount of data, this might take a
						while. You will receive an email once the export is ready.
					</p>
				{{else if @model.isError}}
					<p>
						We've encountered the following error while generating your export
						<strong>"{{@model.dataExportDelivery.name}}"</strong>:
						{{@model.errorText}}
					</p>
				{{else}}
					<div>
						<span class="title">{{@model.dataExportDelivery.name}} Export</span>
						<p>
							{{@model.dataExportDelivery.fileSize}}
							-
							{{@model.dataExportDelivery.type}}
							document file
						</p>
					</div>
					<div class="controls2">
						<div class="controls2__right">
							<a class="close" {{on "click" @onClose}}>Dismiss</a>
							{{#if @model.dataExportDelivery.url}}
								<a class="button theme-grey">
									<CommonUiIconComponent @name="Copy" @size="sm" />Copy URL
									<ClipboardCopyComponent
										@text={{@model.dataExportDelivery.url}}
										@onAfterCopy={{this.onAfterCopyToClipboard}}
									/>
								</a>
							{{/if}}
							<a class="button" {{on "click" this.download}}>
								<CommonUiIconComponent @name="Download" @size="sm" />Download
							</a>
						</div>
					</div>
				{{/if}}
			</div>
		</div>
	</template>
}
